import React from 'react';
import * as request from 'superagent';
import { API_SERVICEENDPOINT, API_SERVICEENDPOINT_LAB } from '../constants/endpoints';
import TagManager from 'react-gtm-module'
// Each site type is loaded on demand (see lazyParts.mjs)
import { AppLab, AppMed, AppLotus, AppGSM, AppLink, loadCloudscapeTheming, preloadSiteApp } from './lazyParts.mjs';

// Longest wait for the site's data before showing the error page
const API_TIMEOUT = { response: 20000, deadline: 60000 };

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      company: [],
      config: null,
      failed: false
    };
  }

  // The API's JSON, or null after showing the error page: a failed request (or an unknown site, for
  // which /Start answers null) used to leave the loader spinning forever
  readResponse(err, res, check) {
    let obj = null;
    if (!err && res != null && res.ok) {
      try {
        obj = JSON.parse(res.text);
      } catch (e) {
        obj = null;
      }
    }
    if (obj == null || !check(obj)) {
      console.error("Site data request failed", err || (res && res.status) || "unexpected response");
      this.setState({ failed: true });
      return null;
    }
    return obj;
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("Site failed to load", error);
  }

  componentDidMount() {
    let self = this;

    request
      .post(API_SERVICEENDPOINT + '/api/online/Start')
      .set('Content-Type', 'application/json;charset=UTF-8')
      .set('Access-Control-Allow-Origin', '*')
      .timeout(API_TIMEOUT)
      .end(function (err, res) {
        let obj = self.readResponse(err, res, o => o.client && o.client.length > 0);
        if (obj != null) {
          // The site's app downloads while the company data is requested
          preloadSiteApp(obj.client[0].type);
          self.setState({ config: obj }, function () {

            let where = API_SERVICEENDPOINT;

            if (obj.client[0].type == "lab")
              where = API_SERVICEENDPOINT_LAB;

            if (obj.client[0].type == "link") {
              const theme = {
                tokens: {
                  fontSizeBodyM: "1.5rem",
                  colorBackgroundContainerContent: { "light": "#f5f5f5" },
                  colorBackgroundContainerHeader: { "light": "#f5f5f5" },
                  fontFamilyBase: "'Helvetica Neue', Arial, sans-serif",
                  colorBackgroundLayoutMain: {
                    // Specify value for light and dark mode
                    light: 'blue-300',
                    dark: 'blue'
                  },
                  // Shorter syntax to apply the same value for both light and dark mode
                  colorTextAccent: '#0073bb',
                },
                contexts: {
                  // Values for visual contexts. Unless specified, default values will be applied
                  'top-navigation': {
                    tokens: {
                      colorTextAccent: '#44b9d6'
                    },
                  },
                  header: {
                    tokens: {
                      colorBackgroundLayoutMain: {
                        // Specify value for light and dark mode
                        light: '#f2f8fd',
                        dark: '#f2f8fd'
                      },
                      colorTextHeadingDefault: {
                        // Specify value for light and dark mode
                        light: 'black',
                        dark: 'black'
                      },
                    }
                  }
                },
              };
              loadCloudscapeTheming().then(({ applyTheme }) => applyTheme({ "theme": theme }));
            }

            if ((obj.client[0].type == "lab") || (obj.client[0].type == "med"))
              request
                .post(where + '/api/online/Company')
                .set('Content-Type', 'application/json;charset=UTF-8')
                .set('Access-Control-Allow-Origin', '*')
                .timeout(API_TIMEOUT)
                .end(function (err, res) {
                  let obj = self.readResponse(err, res, o => o.CONFC_Name != null);
                  if (obj != null) {
                    self.setState({ company: obj }, function () {
                      self.setState({ loading: false })
                      const tagManagerArgs = {
                        gtmId: this.state.company.CONFC_GoogleAnalitics
                      }
                      TagManager.initialize(tagManagerArgs)
                    });
                  }
                });
            else
              self.setState({ loading: false })

          });





        }
      });


  }



  renderLoader() {
    return (
      <div id="loader-wrapper">
        <div id="loader">
          <div className="loader-inner"></div>
        </div>
      </div>
    );
  }

  renderApp() {
    if (this.state.config.client[0].type == "med")
      return (
        <AppMed company={this.state.company} config={this.state.config}></AppMed>
      )

    if (this.state.config.client[0].type == "lab")
      return (
        <AppLab company={this.state.company} config={this.state.config}></AppLab>
      )

    if (this.state.config.client[0].type == "lotus")
      return (
        <AppLotus></AppLotus>
      )

    if (this.state.config.client[0].type == "gsm")
      return (
        <AppGSM></AppGSM>
      )

    if (this.state.config.client[0].type == "link")
      return (
        <AppLink></AppLink>
      )

    return (<div>Nothing</div>)
  }

  render() {
    if (this.state.failed)
      return (
        <div className="container text-center" style={{ padding: "80px 15px" }}>
          <h1 className="h3">Site-ul nu poate fi încărcat momentan</h1>
          <p>Vă rugăm să încercați din nou peste câteva momente.</p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>Reîncarcă pagina</button>
        </div>
      );

    if (this.state.loading)
      return this.renderLoader();

    return (
      <React.Suspense fallback={this.renderLoader()}>
        {this.renderApp()}
      </React.Suspense>
    );
  }

}

export default App;
